import styled from "styled-components";
import { pendingStyles } from "../styled";

export const Modal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  z-index: 9999;
`;

export const ModalLayout = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--background-overlay, rgba(20, 16, 15, 0.8));
  backdrop-filter: blur(12px);
`;

export const ModalBody = styled.div`
  position: absolute;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  top: auto;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 8px 32px 0px rgba(51, 20, 0, 0.16);
  overflow: scroll;
  scroll-behavior: smooth;
  scrollbar-width: 0px;
  scrollbar-color: rgba(255, 255, 255, 0);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  background: var(--background-primary, #000);

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-track-piece {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }

  &.short {
    height: fit-content;
  }

  &.padded,
  .padded {
    padding: 60px 24px 12px;
  }

  &.sm {
    width: 520px;
  }

  &.middle-high {
    height: calc(100% - 74px);
    max-height: calc(100% - 74px);
  }
  &.rubber-height {
    height: auto;
    max-height: auto;
  }
  &.notification {
    height: auto;
    width: 520px;
    min-height: 278px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 24px;
    box-sizing: border-box;
    max-width: calc(100% - 18px);
    bottom: 9px;
    border-radius: 32px;

    @media (min-width: 1024px) {
      top: 50%;
      bottom: auto;
    }
  }

  &.empty-position {
    height: 278px;
  }

  p {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #000000;
    font-family: "PlusJakartaSans", "Medium", sans-serif;
    font-variation-settings: "wght" 500;
    & + p {
      margin-top: 24px;
    }
  }

  @media (min-width: 1024px) {
    max-height: calc(100vh - 64px);
    border-radius: var(--rounding-radius-xxxl, 48px);
    max-height: calc(100% - 128px);
    left: 50%;
    top: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    border-radius: 32px;
    height: fit-content;
    background: var(--background-elevated, #252222);
    padding-top: 0;
    &.padded,
    .padded {
      padding: 24px;
      overflow: auto;
    }

    &.empty-position {
      height: fit-content;
    }
  }
`;

export const ModalCross = styled.button`
  background: transparent;
  border: 0;
  outline: 0;
  padding: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 32px;
  right: 32px;
  filter: invert(1);
  .arrow {
    display: none;
  }

  @media (max-width: 1024px) {
    top: 16px;
    left: 16px;
    right: auto;
    filter: invert(0);
    z-index: 9999;

    .arrow {
      display: block;
    }
    .cross {
      display: none;
    }
  }
`;

export const UserInfo = styled.div`
  background: #99ffee;
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  margin-bottom: 14px;
`;

export const ModalHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 200ms ease-out;
  padding-bottom: 12px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
  background: var(--background-primary, #000);

  &.bannered {
    background: var(--background-elevated, #252222);
  }

  &.filled {
    padding: 24px;
    background: #f7f3f2;
    background-blend-mode: multiply;
  }

  &.green {
    background: #99ffee;
  }

  &.no-flex {
    display: block;
  }
  .subflex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    ${ModalCross} {
      transform: translateY(10px);
    }
  }
  @media (min-width: 1024px) {
    padding-bottom: 24px;
    background: var(--background-elevated, #252222);
    &.colored {
      background: var(--background-elevated, #252222);
    }
  }
`;

export const IndividualTeamHeading = styled.div`
  transition: 200ms ease-out;
  padding-bottom: 12px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
  background: #fff;

  &.colored {
    background: #f7f3f2;
  }

  .subflex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    ${ModalCross} {
      transform: translateY(10px);
    }
    & > div:last-child {
      text-align: right;
    }
  }
`;

export const Subtext = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: rgba(66, 61, 60, 0.64);
`;

export const SelectModalHeading = styled.div`
  transition: 200ms ease-out;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
  padding: 24px 24px 12px;

  &.colored {
    background: #f7f3f2;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SearchLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 1;
  display: block;
  color: rgba(66, 61, 60, 0.64);
  transition: 200ms ease-out;
`;

export const SearchBar = styled.div`
  background: rgba(204, 187, 184, 0.16);
  border-radius: 16px;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
  display: flex;
  transition: 200ms ease-out;
  position: relative;
  height: 64px;

  & > div:nth-child(2) {
    width: 100%;
  }

  .alert {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    object-fit: contain;
    opacity: 0;
    transition: 200ms ease-out;
  }

  input {
    border: 0;
    outline: 0;
    width: 100%;
    background: transparent;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.16px;
    caret-color: #000;
    padding: 0 30px 0 0;
    &::placeholder {
      color: rgba(66, 61, 60, 0.64);
    }
  }
  ${SearchLabel} {
    display: none;
  }
  &.focused {
    background: transparent;
    box-shadow: inset 0 0 0 2px #000;
    ${SearchLabel} {
      display: block;
    }
  }
  &.error {
    background: rgba(240, 165, 204, 0.16);
    box-shadow: none;
    ${SearchLabel} {
      color: #e54796;
    }
    .alert {
      opacity: 1;
    }
  }
`;

export const ParagraphHeading = styled.span`
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #000000;
  font-variation-settings: "wght" 700;
  padding: 12px 0;
  display: block;
`;

export const ModalOverflow = styled.div`
  position: relative;
  min-height: 82vh;
  height: auto;
  padding-bottom: 18px;

  .epic-item {
    margin-left: 24px;
  }

  scroll-behavior: smooth;
  scrollbar-width: 0px;
  scrollbar-color: rgba(255, 255, 255, 0);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  &.padded {
    padding-bottom: 14px;
    padding-top: 4px;
  }
  @media (min-width: 1024px) {
    height: fit-content;
    padding-bottom: 24px;

    &.padded {
      padding-bottom: 44px;
    }
    &.short {
      max-height: calc(100vh - 124px - 72px);
      height: fit-content;
    }
  }

  ${pendingStyles}
`;

export const NotificationModalTitle = styled.div`
  font-size: 24px;
  line-height: 1.3;
  font-variation-settings: "wght" 700;
  letter-spacing: 0.24px;
`;

export const UserInfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px;
  & + & {
    margin-top: 20px;
  }
  & > div {
    display: flex;
    gap: 4px;
    align-items: center;
    .arrow {
      transition: 200ms ease-out;
      cursor: pointer;
      &.rotated {
        transform: rotate(180deg);
      }
    }
  }
`;

export const TopLabel = styled.div`
  background: #99ffee;
  border-radius: 16px;
  padding: 2px 6px;
  letter-spacing: 0.5px;
  font-size: 12px;
  font-style: italic;
  line-height: 1;
`;

export const NoResults = styled.div`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: rgba(41, 35, 35, 0.72);
  margin-top: -8px;
`;
